import { namespace, schema, backendDocType, docPrivilege } from './config'

import { useTranspile } from './common'
import loader, {
  FeeTableRestorer,
  generateReferenceDoc,
  queryManifest,
} from './loader'
import listview from './listview'
import compareview from './compare'
import { ticketProfile, useScopeName } from './ticket'
import { addViewManifest } from '../Config'

const manifest = {
  loader,
  schema,
  namespace,
  backendDocType,
  privilege: docPrivilege,
  queryManifest,
  useTranspile,
  generateReferenceDoc,
  restore: FeeTableRestorer,
  listview,
  compareview,
  ticketProfile,
  useScopeName,
  order: 4,
}

addViewManifest(manifest)
